import React from 'react';
import { useUserProfile } from '@backstage/plugin-user-settings';
import { DevQuote } from '@parsifal-m/plugin-dev-quotes-homepage';
import {
  Typography,
  styledComponent,
} from '@dewise-devex/backstage-plugin-mui-uikit-react';

const QuoteContainer = styledComponent('div')(() => ({
  position: 'relative',
  textAlign: 'left',
  '& footer': {
    textAlign: 'left',
  },
  '& h6': {
    textAlign: 'left',
    display: 'inline-block',
    padding: '5px 15px',
    fontSize: '16px',
    fontWeight: '500',
  },
  '& span': {
    fontSize: '57px',
    fontFamily: 'auto',
    position: 'absolute',
  },
}));

const Greeting = () => {
  const { profile } = useUserProfile();
  const getCurrentGreeting = (): string => {
    const currentHour = new Date().getHours();

    if (currentHour < 12) {
      return '🌞 Good morning ';
    } else if (currentHour < 18) {
      return '🌞 Good afternoon';
    }
    return '🌙 Good evening';
  };

  const greetingMessage = getCurrentGreeting();

  return (
    <>
      <Typography variant="headlineSM">
        {`${greetingMessage}, ${profile.displayName}!`}
      </Typography>

      <QuoteContainer>
        <span>“</span>
        <DevQuote />
      </QuoteContainer>
    </>
  );
};

export default Greeting;
